<template>
    <b-container>
        <input id="testing-code" type="hidden" :value="extracted_texts">
        <b-row>
            <b-col md="4">
                <div class="box">
                    <div class="card-content" id="sample">
                        <div class="title mb-2">画像を選択してください</div>
                        <div class="description">
                            左の赤いボタンを押して画像をアップロード後、<br/>
                            緑のコピーボタンを押すことで<br>
                            抽出した文章をコピーし、テキストやワードへ<br/>
                            貼り付けることができます。
                        </div>
                        <div class="img-container">
                            <div class="box-item" @click="onPickFile" title="Click here to upload file">
                                <div class="box-add">
                                    <font-awesome-icon icon="images"/>
                                </div>
                            </div>
                            <div class="box-item" v-for="(item, i) in images" :key="i">
                                <b-img
                                    :src="item"
                                    @click="showImage"
                                    :data-index="i"
                                    rounded="circle"
                                    class="img-item"
                                    alt="Circle image"
                                    :class="i == index ? 'img-active': '' "
                                >
                                </b-img>
                            </div>
                            <div class="clear-fix"></div>
                        </div>
                        <div class="flex-action">
                            <b-button pill class="btn-copy" @click="copyText">
                                <font-awesome-icon icon="copy"/>
                                &nbsp;抽出したテキストをコピー
                            </b-button>
                        </div>
                        <input type="file" style="display: none" ref="fileInput" accept='image/*'
                               @change='uploadImage'>
                    </div>
                </div>
            </b-col>
            <b-col md="8">
                <div :class="!responsive ? '': 'hidden'" class="canvas-wrapper" id="custom-scroll-bar">
                    <canvas class="canvas-preview" id="canvas" ref="canvas"></canvas>
                    <div class="tool-tip-text arrow_bottom" id="text" style="visibility: hidden"></div>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<style scoped>
    .box {
        border: 1px solid #2AA974;
        border-radius: 2px;
        margin-bottom: 1rem;
    }

    .card-content {
        padding: 1.3rem;
    }

    .btn-copy {
        background-color: #2AA974;
        border-color: #2AA974;
        width: auto;
        padding: 0 2em;
        height: 3em;
    }

    .img-container {
        margin-bottom: 3rem
    }

    .box-item {
        width: 25%;
        float: left;
    }

    .clear-fix {
        clear: both
    }

    .flex-action {
        display: flex;
        justify-content: center;
    }

    .img-item {
        width: 61px;
        height: 61px;
        cursor: pointer;
        margin-bottom: 1rem;
        box-shadow: 0 2px 5px grey;
        border: 1px solid #ebebeb;
        max-width: 100%;
    }

    .img-item:hover {
        box-shadow: 0 6px 6px grey;
    }

    .img-active {
        box-shadow: 0 6px 6px red
    }

    .box-add {
        width: 61px;
        height: 61px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #EA5455;
        margin-bottom: 1rem;
        border-radius: 50%;
        color: white;
        cursor: pointer;
        box-shadow: 0 2px 5px grey;
    }

    .title {
        font-family: "Open Sans";
        font-weight: bold;
        font-size: 24px;
        line-height: 33px;
        color: #000000;
    }

    .description {
        font-family: 'Open Sans';
        font-size: 14px;
        line-height: 28px;
        letter-spacing: -0.25px;
        color: grey;
        margin-bottom: 35px;
    }

    .canvas-wrapper {
        position: relative;
        background-color: #E5E5E5;
        border-radius: 2px;
        border: 1px solid #E5E5E5;
        max-width: 700px;
        max-height: 530px;
        overflow: scroll;
    }

    .canvas-preview {
        display: block;
        margin: auto;
    }

    .hidden{
        display: none;
    }
    .show{
        display: block;
    }

    .tool-tip-text {
        position: absolute;
        top: 20px;
        left: 20px;
        background-color: white;
        color: black;
        border-radius: 3px;
        text-align: center;
        padding: 5px;
        border: 1px solid #ebebeb;
        z-index: 1;
        margin: auto;
        display: block;
        width: auto;
        font-size: 13px;
        min-width: 50px;
        box-shadow: 0 3px 15px #2AA974;
        white-space: nowrap;
    }

    .arrow_bottom {
        background: #fff;
        border: 2px solid #ebebeb;
    }

    .arrow_bottom:after, .arrow_bottom:before {
        top: 100%;
        left: 50%;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
    }

    .arrow_bottom:after {
        border-color: rgba(255, 255, 255, 0);
        border-top-color: #fff;
        border-width: 5px;
        margin-left: -5px;
    }

    .arrow_bottom:before {
        border-color: rgba(235, 235, 235, 0);
        border-top-color: #ebebeb;
        border-width: 8px;
        margin-left: -8px;
    }

    .arrow_top {
        background: #fff;
        border: 2px solid #ebebeb;
    }
    .arrow_top:after,
    .arrow_top:before {
        bottom: 100%;
        left: 50%;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
    }

    .arrow_top:after {
        border-color: rgba(255, 255, 255, 0);
        border-bottom-color: #fff;
        border-width: 5px;
        margin-left: -5px;
    }
    .arrow_top:before {
        border-color: rgba(235, 235, 235, 0);
        border-bottom-color: #ebebeb;
        border-width: 8px;
        margin-left: -8px;
    }

    #custom-scroll-bar::-webkit-scrollbar {
        width: 5px;
        height: 5px;
    }

    #custom-scroll-bar::-webkit-scrollbar-thumb {
        border-radius: 2px;
        background: #5acdc8;
    }

    @media only screen and (max-width: 768px) {
        .canvas-wrapper {
            overflow-x: scroll;
        }

        .custom-md {
            /*margin: 0 15px;*/
            /*width: calc(100% - 30px);*/
            /*box-shadow: 0 2px 5px grey;*/
        }

        .btn-copy {
            width: 100%;
        }
    }

    @media only screen and (max-width: 380px) {
        .card-content{
            padding: 1rem;
        }
    }

    @media only screen and (width: 360px) {
        .description{
            font-size: 13px;
        }
    }

    @media only screen and (min-width: 320px) and (max-width: 359px) {
        .title{
            font-size: 20px;
        }
        .description{
            font-size: 12px;
            margin-bottom: 1rem;
            line-height: 20px;
        }
        .card-content{
            padding: 0.8rem;
        }
        .img-container{
            margin-bottom: 2rem;
        }
        .btn-copy{
            font-size: 1em;
        }
    }

    @media only screen and (max-width: 767px) {
        .container{
            max-width: initial;
        }
    }

</style>

<script>
    import axios from "axios";
    import https from "https";
    import {Loading, Message, Notification} from "element-ui";
    import {apiPredict} from '../../enviroments/enviroments'
    import imageService from '../../services/ImageService';
    import AnalyticService from '../../services/AnalyticService';

    export default {
        data() {
            return {
                selectedFile: null,
                extracted_texts: "",
                extracted_bbs: [],
                currentIndex: null,
                index: null,
                isShowed: true,
                responsive: false,
                img: new Image(),
                images: [
                    require('../../assets/ocr-form/pub_form1.png'),
                    require('../../assets/ocr-form/pub_form2.png'),
                    require('../../assets/ocr-form/pub_form3.png'),
                ],
            };
        },
        mounted() {
            this.initCanvas();
            this.onResponsiveInverted();
            window.addEventListener("resize", this.onResponsiveInverted);
        },
        beforeDestroy() {
            window.removeEventListener("resize", this.onResponsiveInverted);
        },
        methods: {
            onResponsiveInverted() {
                this.responsive = window.innerWidth < 768;
            },
            showResultBox(){
                document.getElementById('custom-scroll-bar').className += ' show';
            },
            initCanvas(width = 700, height = 530) {
                this.canvas = this.$refs.canvas;
                this.ctx = this.canvas.getContext("2d");
                this.ctx.canvas.width = width;
                this.ctx.canvas.height = height;
            },
            showImage: function (img) {
                this.resetTooltip();
                this.index = img.target.getAttribute('data-index') || null;
                this.drawTextBoxCanvas(img.target.src);
            },
            onPickFile() {
                this.$refs.fileInput.click();
            },
            uploadImage(event) {
                this.resetTooltip();
                const files = event.target.files;

                if (files && files[0]) {
                    let reader = new FileReader();
                    reader.onload = (e) => {
                        this.img.src = e.target.result;
                    };
                    reader.readAsDataURL(files[0]);
                    this.img.onload = () => {
                        // start log event upload_image to analytics
                        this.initCanvas(
                            this.img.width,
                            this.img.height
                        );
                        AnalyticService.logUploadEvent();
                        // draw text to canvas
                        this.drawTextBoxCanvas(this.img.src);
                    }
                }
            },
            copyText() {
                let textToCopy = document.querySelector("#testing-code");
                textToCopy.setAttribute("type", "text");
                textToCopy.select();

                try {
                    document.execCommand("copy");
                    if (this.extracted_texts === "") {
                        Notification.error('画像内に文字が無いと認識しました。画像をもう１度ご確認ください。');
                    } else {
                        Notification.success("抽出したテキストをコピーしました。");
                    }
                } catch (err) {
                    Notification.error("申し訳ございませんが、コピーできませんでした。しばらくしてから、もう1度お試しください。");
                }
                textToCopy.setAttribute("type", "hidden");
                // Fixed issue open keyboard in mobile
                textToCopy.blur();
                window.getSelection().removeAllRanges();
            },
            detectText(event) {
                const rect = event.target.getBoundingClientRect();
                const offsetX = rect.left;
                const offsetY = rect.top;
                const mouseX = parseInt(event.clientX - offsetX);
                const mouseY = parseInt(event.clientY - offsetY);

                let text;
                let bbs = null;
                let index = null;

                for (let i = 0; i < this.extracted_bbs.length; i++) {
                    if (
                        mouseX >= this.extracted_bbs[i].x &&
                        mouseX <= this.extracted_bbs[i].x + this.extracted_bbs[i].w &&
                        mouseY >= this.extracted_bbs[i].y &&
                        mouseY <= this.extracted_bbs[i].y + this.extracted_bbs[i].h
                    ) {
                        text = this.extracted_texts[i];
                        bbs = this.extracted_bbs[i];
                        index = i;
                    }
                }
                // get element tooltip
                const el = document.getElementById('text');
                // show popOver
                if (index === this.currentIndex && el.textContent.length) {
                    return el.style.visibility = 'visible';
                }
                if (!text) {
                    return this.resetTooltip();
                }
                this.currentIndex = index;
                return this.showPopupText(bbs, text);
            },
            showPopupText(bbs, text) {
                const element = document.getElementById('text');
                const parent = document.getElementById('custom-scroll-bar');

                const _width = parent.offsetWidth;
                const _height = parent.offsetHeight;

                let scrollWidth = (_width - this.canvas.width) / 2;
                let scrollHeight = (_height - this.canvas.height);

                if (scrollWidth < 0) {
                    scrollWidth = 0;
                }
                if (scrollHeight < 0) {
                    scrollHeight = 0;
                }

                element.style.left = bbs.x + scrollWidth + 'px';
                element.textContent = text;
                element.style.visibility = 'visible';
                // Fixed issue text in the top image
                let positionTop = bbs.y + scrollHeight - 40;
                if (positionTop < 0){
                    positionTop = bbs.y + + bbs.h + 5;
                    element.className = 'tool-tip-text arrow_top'
                }else{
                    element.className = 'tool-tip-text arrow_bottom'
                }
                element.style.top = positionTop + 'px';
            },
            drawTextBoxCanvas(url) {
                this.extracted_texts = '';
                this.extracted_bbs = [];
                this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
                this.ctx.beginPath();
                let loadingInstance = Loading.service({
                    text: "画像内の文字を認識中です...",
                    fullscreen: true,
                    customClass: 'test'
                });

                imageService.getBase64FromSrc(url)
                    .then(response => {
                        this.img.src = "data:image/png;base64," + response;
                        this.img.onload = () => {
                            // Draw
                            this.initCanvas(
                                this.img.width,
                                this.img.height
                            );
                            this.ctx.drawImage(
                                this.img,
                                0,
                                0,
                                this.img.width,
                                this.img.height,
                                0,
                                0,
                                this.canvas.width,
                                this.canvas.height
                            );
                            const data = {
                                image: this.img.src
                            };
                            const config = {
                                httpsAgent: new https.Agent({
                                    rejectUnauthorized: false
                                }),
                                rejectUnauthorized: false
                            };
                            axios.post(apiPredict, data, config)
                                .then(res => {
                                    this.showResultBox();
                                    const bbs = res.data.bbs;
                                    this.extracted_texts = res.data.texts;
                                    // iterate over returned bounding boxes and draw respecting rectangles
                                    let scale_x = this.img.width / this.canvas.width;
                                    let scale_y = this.img.height / this.canvas.height;
                                    // clear old bounding box
                                    this.ctx.beginPath();
                                    for (let i = 0; i < bbs.length; i++) {
                                        let x = bbs[i][0][0] / scale_x;
                                        let y = bbs[i][0][1] / scale_y;
                                        let w = (bbs[i][2][0] - bbs[i][0][0]) / scale_x;
                                        let h = (bbs[i][2][1] - bbs[i][0][1]) / scale_y;
                                        this.ctx.lineWidth = 1;
                                        this.ctx.stroke();
                                        this.ctx.rect(x, y, w, h);
                                        this.extracted_bbs.push({x: x, y: y, w: w, h: h});
                                    }
                                    this.ctx.font = "25px Arial";
                                    this.isLoading = false;
                                    loadingInstance.close();
                                })
                                .catch(() => {
                                    loadingInstance.close();
                                    Notification.error(`申し訳ございませんが、OCRを正常に実行できませんでした。しばらくしてから、もう1度お試しください。`);
                                    this.showResultBox();
                                });
                        };
                        this.canvas.addEventListener("mousedown", this.detectText, false);
                    })
                    .catch(error => {
                        Notification.error(error)
                    });
            },
            resetTooltip() {
                document.getElementById('text').style.visibility = 'hidden';
            }
        }
    };
</script>
